"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface OtherLiabilitiesTailoringQuestionsProps {
  onBack?: () => void;
}

const QUESTIONS: TailoringQuestion[] = [
  {
    id: "othlib-1",
    question: "Are there any accounting estimates related to other liabilities?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "othlib-2",
    question: "Does the entity have material advance from customers as at period-end?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "othlib-2-follow",
      question: "Are we planning on sending confirmations for testing the balance?",
      type: "radio",
      options: ["Yes", "No"],
    },
  },
  {
    id: "othlib-3",
    question: "Does the entity have material payables to capex vendors as at period-end?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "othlib-3-follow",
      question: "Are we planning on sending confirmations for testing the balance?",
      type: "radio",
      options: ["Yes", "No"],
    },
  },
  {
    id: "othlib-4",
    question: "Does the entity have material current and non-current classification of other liabilities in financial statements?",
    type: "radio",
    options: ["Yes", "No"],
  },
];

export default function OtherLiabilitiesTailoringQuestions({ onBack }: OtherLiabilitiesTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Other Liabilities"
      title="Other Liabilities - Tailoring Questions"
      description="Customize the audit program for Other Liabilities"
      questions={QUESTIONS}
      onBack={onBack}
    />
  );
}
